import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Dashboard from '../../presentational/Dashboard/Dashboard';
import { useAdviserDetails } from '../../hooks/AppStateHook';
import { getRecentClientsResultsAction } from '../../../store/actions/recent-clients.actions';
import callToActionItems from './__data__/data.callToActionItems.json';
import externalLinksList from './__data__/data.externalLinksList.json';

const DashboardContainer = () => {
	const dispatch = useDispatch();
	const { customerNumber, customerToken } = useAdviserDetails();
	const [clientLeadsCounter, setClientLeadsCounter] = React.useState(0);

	useEffect(() => {
		if (customerToken) {
			dispatch(getRecentClientsResultsAction(customerToken));
		}
	}, [customerToken, customerNumber]);

	return (
		<Dashboard
			actionItems={callToActionItems}
			externalLinksList={externalLinksList}
		/>
	);
};

export default DashboardContainer;
